import compose from 'recompose/compose'

import IncomeStatement from './IncomeStatement'

import withSchema from './withSchema'
import withQueriesState from './withQueriesState'

const enhancer = compose(
  withSchema,
  withQueriesState,
)


module.exports = enhancer(IncomeStatement)



// WEBPACK FOOTER //
// ./src/components/IncomeStatement/index.js